var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.997,
    height: 12,
    viewBox: "0 0 11.997 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Button_Icon",
    "data-name": "Button Icon",
    d: "M-.185.539-3.326-2.6A4.73,4.73,0,0,0-2.271-5.625,4.875,4.875,0,0,0-7.146-10.5,4.857,4.857,0,0,0-12-5.625,4.871,4.871,0,0,0-7.146-.75,4.846,4.846,0,0,0-4.123-1.806L-.982,1.335a.648.648,0,0,0,.42.165.563.563,0,0,0,.4-.165A.548.548,0,0,0-.185.539Zm-10.69-6.164a3.754,3.754,0,0,1,3.75-3.75,3.754,3.754,0,0,1,3.75,3.75,3.754,3.754,0,0,1-3.75,3.75A3.755,3.755,0,0,1-10.875-5.625Z",
    transform: "translate(12 10.5)",
    fill: "#52576a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.020565cdd2a1e33491871337b1368243.svg";
export { ForwardRef as ReactComponent };